export default __webpack_public_path__ + "static/media/painel_covid.0f63befd.svg";